import type {AccountType} from "@hosttools/core/constant";
import {Box, ChannelLogo, ConnectIcon, HStack, Link} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

export type Props = {
    channel: AccountType;
};

const ChannelHeader: React.FC<Props> = ({channel}) => {
    return (
        <HStack
            className="items-center justify-center bg-blueGray-50 px-4 py-3 rounded-lg my-2"
            space="lg"
        >
            <Box className="rounded-full overflow-hidden border-2 border-solid border-white shadow-md">
                {channel === "Seam" ? (
                    <Link
                        href="https://help.hosttools.com/en/articles/6066284-do-you-support-smart-locks"
                        type="external"
                    >
                        <ChannelLogo channel={channel} size="3xl" />
                    </Link>
                ) : (
                    <ChannelLogo channel={channel} size="2xl" />
                )}
            </Box>
            <ConnectIcon fill="blueGray.600" size="lg" />
            <ChannelLogo channel="internal" size="2xl" />
        </HStack>
    );
};

export default memo(ChannelHeader);
